import { Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField, Button } from '@material-ui/core';
import { DeleteIconButton } from 'components';
import { applicationContext } from 'helpers/services';
import { useContext, useState } from 'react';
import { ticketContext } from 'views/Ticket/TicketContext';
import { Autocomplete } from '@material-ui/lab';

let Notifications = () => {
    let { customerServiceUsers, } = useContext(applicationContext);
    let { ticket, watcherUsers, assignableUsers, updateWatchers } = useContext(ticketContext);

    let [watcher, setWatcher] = useState('');


    return (
        <>
            <Grid container>
                <Grid item xs>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {(ticket.assignee && ticket.assignee !== '') ?
                                <TableRow>
                                    <TableCell>{assignableUsers.getValueByKey(ticket.assignee, 'email', 'name')}</TableCell>
                                    <TableCell align="right">Assignee</TableCell>
                                </TableRow> : null
                            }
                            {(ticket.customerServiceAssignee && ticket.customerServiceAssignee !== '') ?
                                <TableRow>
                                    <TableCell>{customerServiceUsers.getValueByKey(ticket.customerServiceAssignee)}</TableCell>
                                    <TableCell align="right">Customer Service Assignee</TableCell>
                                </TableRow> : null
                            }
                            {(ticket.reporter && ticket.reporter !== '') ?
                                <TableRow>
                                    <TableCell>{ticket.reporterName}&nbsp;&middot;&nbsp;{ticket.reporterCompany}</TableCell>
                                    <TableCell align="right">Reporter</TableCell>
                                </TableRow> : null
                            }
                            {ticket.watchers && ticket.watchers.length !== 0 &&
                                ticket.watchers.map(user =>
                                    <TableRow key={user}>
                                        <TableCell>{user}</TableCell>
                                        <TableCell align="right">
                                            {ticket.isReadOnly === false &&
                                                <DeleteIconButton
                                                    onClick={() => {
                                                        if (window.confirm("Are you sure that you don't want to notify this user?")) {
                                                            updateWatchers(ticket.watchers.filter(x => x !== user))
                                                        }
                                                    }}
                                                />
                                            }
                                        </TableCell>
                                    </TableRow>
                                )}
                        </TableBody>
                    </Table>
                </Grid>
            </Grid>

            {watcherUsers.length > 0 && ticket.isReadOnly === false &&
                <Grid container>
                    <Grid item xs>
                        <Autocomplete
                            value={watcher}
                            onChange={(e, newValue) => setWatcher(newValue || '')}
                            getOptionLabel={(option) => assignableUsers.getValueByKey(option, 'email', 'name')}
                            options={watcherUsers.map(x => x.email)}
                            renderInput={(params) =>
                                <TextField {...params} variant="outlined" fullWidth label="Add user to notify" />
                            }
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            color="secondary"
                            variant="outlined"
                            onClick={() => {
                                if (ticket.watchers.indexOf(watcher) === -1 && watcher !== "") {
                                    ticket.watchers.push(watcher);
                                    updateWatchers(ticket.watchers);
                                }
                                setWatcher('');
                            }}
                        >
                            Confirm
                        </Button>
                    </Grid>
                </Grid>
            }
        </>
    )
}

export default Notifications;